import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = ["widget", "message"];

  connect() {
    const coin = this.widgetTarget.getAttribute("data-coin-id");
    const token = this.widgetTarget.getAttribute("data-token");

    ((w, d, s, o, f, js, fjs) => {
      w["simetri-report-widget"] = o;
      w[o] =
        w[o] ||
        function() {
          (w[o].q = w[o].q || []).push(arguments);
        };
      (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
      js.id = o;
      js.src = f;
      js.async = 1;
      //setTimeout for waiting widget loaded and set window['simetri-report-widget-initialized'] to check is coin support
      js.onload = () => {
        setTimeout(() => {
          if (!window["simetri-report-widget-initialized"]) {
            this.messageTarget.innerText = `Ratings not available in ${coin}`;
          }
        }, 3000);
      };
      fjs.parentNode.insertBefore(js, fjs);
    })(
      window,
      document,
      "script",
      "simetriRW",
      "https://d3g6txjafmxxhm.cloudfront.net/simetri/widget/srw-v1.0.js"
    );

    simetriRW("init", {
      token: token,
      origin: "coingecko",
      cg_id: coin,
      theme: Cookies.get("is_dark") === "true" ? "night" : "day"
    });
  }
}
